import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import './RepaymentRemarksModal.css'

const LoanInterestModalUI = ({ context, successMsg, errorList, setErrorList,
	// modes
	loanInterestMode, submitted,
	// event handlers
	onSubmit, onLoanInterestCancel,
	// fields
	startDate, onStartDateChange, startDateError, setStartDateError,
	endDate, onEndDateChange, endDateError, setEndDateError
}) =>
	<ModalFormUI
		context={context}
		titleLabel='Download loan interest certificate'
		buttonLabel='Download'
		cancelLabel='Cancel'
		isOpen={loanInterestMode}
		onRequestClose={onLoanInterestCancel}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>
		<InputDateUI context={context} name='date' label='Start date'
			selectedDateISO={startDate} onChange={onStartDateChange}
			error={startDateError} setError={setStartDateError}
			required={true}
		/>
		<InputDateUI context={context} name='date' label='End date'
			selectedDateISO={endDate} onChange={onEndDateChange}
			error={endDateError} setError={setEndDateError}
			required={true}
		/>

	</ModalFormUI>

export default LoanInterestModalUI
